import { FaCircle } from 'react-icons/fa'

const STATUS = ( value, green, red ) => {
  return <FaCircle style={ {
    color: value ? green : red
  } } />
}

export default STATUS
